/**
 * Checks whether a given path matches a pattern.
 *
 * Supported patterns:
 *   *          → matches any path
 *   /          → exact root match
 *   /contact   → exact match
 *   /blog/*    → matches /blog and anything under /blog/
 */
function matchPattern(pattern: string, path: string): boolean {
  if (pattern === '*') return true
  if (pattern.endsWith('/*')) {
    const prefix = pattern.slice(0, -2)
    return path === prefix || path.startsWith(prefix + '/')
  }
  return path === pattern
}

export function isPathAllowed(allowedPaths: string[], path: string): boolean {
  return allowedPaths.some((pattern) => matchPattern(pattern, path))
}
